import React from "react";
import { useNavigate } from "react-router-dom";
import { Sprout, Beef } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const Categories = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const cats = [
    { key: "produce", icon: Sprout, bg: "#DCE7E2", title: t("category.produce"), desc: t("category.produceDesc") },
    { key: "livestock", icon: Beef, bg: "#E4DED2", title: t("category.livestock"), desc: t("category.livestockDesc") },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-[#14251F] mb-4">{t("category.title")}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        {cats.map((c) => {
          const Icon = c.icon;
          return (
            <button
              key={c.key}
              data-testid={`categories-${c.key}`}
              onClick={() => navigate(`/market?category=${c.key}`)}
              className="text-left rounded-2xl p-6 hover:-translate-y-0.5 transition-transform"
              style={{ backgroundColor: c.bg }}
            >
              <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center mb-4">
                <Icon className="w-7 h-7 text-[#123A2C]" />
              </div>
              <div className="font-bold text-[#14251F] text-xl">{c.title}</div>
              <div className="text-sm text-[#6B7280] mt-1">{c.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Categories;
